<template>
  <UrlModal
    :url="modalUrl"
    :show="showModal"
    @close="showModal = false"
  />
  
  <form @submit.prevent="submitForm">
    <div
      class="form-control"
      :class="{ invalid: !application.isValid }"
    >
      <label for="application">Application</label>
      <select
        id="application"
        v-model="application.val"
        :disabled="isLoading"
        @change="onApplicationChange"
        @blur="clearValidity('application')"
      >
        <option value="">
          -- Select Application --
        </option>
        <option value="BREEZE">
          ICICI Direct
        </option>
        <option value="KITE">
          Zerodha
        </option>
      </select>
      <p v-if="!application.isValid">
        Application must not be empty.
      </p>
    </div>
  
    <div
      class="form-control"
      :class="{ invalid: !token.isValid }"
    >
      <label for="token">Token</label>
      <input
        id="token"
        v-model.trim="token.val"
        type="text"
        :disabled="isLoading"
        @blur="clearValidity('token')"
      >
      <p v-if="!token.isValid">
        Token must not be empty.
      </p>
    </div>
  
    <base-button
      :disabled="isLoading"
      @click="submitForm"
    >
      <span v-if="isLoading">Loading...</span>
      <span v-else>Save Token</span>
    </base-button>
  
    <p
      v-if="errorMessage"
      class="error-message"
    >
      {{ errorMessage }}
    </p>
  </form>
</template>
  
  <script>
  import UrlModal from '../../pages/common/UrlModal.vue';
  
  export default {
    components: { UrlModal },
    props: {
        onFetchRedirectUrl: {
            type: Function,
            required: true
        }
    },
    emits: ['fetch-redirect-url', 'save-token'],
    data() {
      return {
        application: { val: '', isValid: true },
        token: { val: '', isValid: true },
        formIsValid: true,
        showModal: false,
        modalUrl: '',
        isLoading: false,
        errorMessage: ''
      };
    },
    methods: {
      clearValidity(field) {
        this[field].isValid = true;
      },
      validateForm() {
        this.formIsValid = true;
        this.errorMessage = '';
        if (this.application.val === '') {
          this.application.isValid = false;
          this.formIsValid = false;
        }
        if (this.token.val === '') {
          this.token.isValid = false;
          this.formIsValid = false;
        }
      },
      async onApplicationChange() {
        this.clearValidity('application');
        this.errorMessage = '';
        if (!this.application.val) return;
  
        this.isLoading = true;
        const formData = {
          application: this.application.val,
          token: this.token.val,
        };
  
        try {
          //const responseData = await this.$emit('fetch-redirect-url', formData);
          const responseData = await this.onFetchRedirectUrl(formData);
          
          
          console.log(`responseData in TokenForm: ${responseData.regirectionUrl}`)

          if (responseData.regirectionUrl) {
            const width = 600;
            const height = 700;
            const left = (screen.width - width) / 2;
            const top = (screen.height - height) / 2;
            window.open(
                responseData.regirectionUrl,
                '_blank',
                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
            );
          } else {
            this.errorMessage = 'No redirection URL received.';
          }
        } catch (err) {
          this.errorMessage = 'Failed to fetch redirection URL.';
          console.error(err);
        } finally {
          this.isLoading = false;
        }
      },
      submitForm() {
        this.validateForm();
        if (!this.formIsValid) return;
  
        const formData = {
          application: this.application.val,
          token: this.token.val,
        };
        
        console.log('📦 Form Data:', formData);
        this.$emit('save-token', formData);
      }
    }
  };
  </script>
  
  <style scoped>
  .form-control {
    margin: 0.5rem 0;
  }
  label {
    font-weight: bold;
    display: block;
    margin-bottom: 0.5rem;
  }
  input, select {
    display: block;
    width: 50%;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 0.5rem;
    font: inherit;
    transition: all 0.3s ease;
    box-sizing: border-box;
  }
  input:focus, select:focus {
    background-color: #f0e6fd;
    border-color: #3d008d;
  }
  .invalid label {
    color: red;
  }
  .invalid input, .invalid select {
    border: 1px solid red;
  }
  .error-message {
    color: red;
    margin-top: 1rem;
  }
  </style>
  